import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [groups, setGroups] = useState([]);
  const [count, setCount] = useState(0);

  const refresh = useCallback(async () => {
    if (!user) { setGroups([]); setCount(0); return; }
    try {
      const { data } = await api.get("/cart");
      setGroups(data.groups || []);
      setCount(data.count || 0);
    } catch {}
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const add = async (vendor_id, product_name, quantity = 1, note = "") => {
    await api.post("/cart", { vendor_id, product_name, quantity, note });
    await refresh();
  };
  const remove = async (item_id) => { await api.delete(`/cart/items/${item_id}`); await refresh(); };
  const clear = async () => { await api.delete("/cart"); await refresh(); };
  const sendInquiry = async (vendor_id) => {
    const { data } = await api.post(`/cart/send-inquiry/${vendor_id}`);
    await refresh();
    return data;
  };

  return (
    <CartContext.Provider value={{ groups, count, add, remove, clear, sendInquiry, refresh }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
